import { useSuspenseQuery } from '@tanstack/react-query'

import { GetLeadRepresadoPorIdService } from '@/features/clientes/services/get-lead-represado-por-id.service'
import { clientesKeys } from '@/features/clientes/utils'
import type { TLeadRepresadoDetalhes } from '@/shared/interfaces/cliente.types'

export const useSuspenseLeadRepresadoPorId = (id: string) => {
  return useSuspenseQuery<TLeadRepresadoDetalhes>({
    queryKey: clientesKeys.leadRepresadoPorId(id),
    queryFn: async () => new GetLeadRepresadoPorIdService().execute({ id }).then((res) => res.data),
  })
}
